import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Outlet } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
// Pages
import { HomePage } from './pages/HomePage';
import { ProductPage } from './pages/ProductPage';
import { DocsPage } from './pages/DocsPage';
import { SecurityPage } from './pages/SecurityPage';
import { IntegrationsPage } from './pages/IntegrationsPage';
import { FaqPage } from './pages/FaqPage';
import { AboutPage } from './pages/AboutPage';
import { UseCasesPage } from './pages/UseCasesPage';
import { EarlyAccessPage } from './pages/EarlyAccessPage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
// Layout wrapper
function Layout() {
  return <div className="min-h-screen flex flex-col bg-gradient-to-b from-[#e8f7f4] via-white to-[#f0faf8] font-sans text-gray-900" data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Header data-id="element-2" />
      <main id="main-content" className="relative flex-grow w-full" data-id="element-3">
        <img src="https://cdn.magicpatterns.com/uploads/dZMGp4cSEcmifqCXnEWTjK/pexels-googledeepmind-17483870.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover z-0" data-id="element-4" />
        <div className="absolute inset-0 z-0 bg-white/70" data-id="element-5" />
        <div className="relative z-10" data-id="element-6">
          <Outlet data-id="element-7" />
        </div>
      </main>
      <Footer data-id="element-8" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-9">
      <Routes data-id="element-10">
        <Route path="/" element={<Layout data-id="element-12" />} data-id="element-11">
          <Route index element={<HomePage data-id="element-14" />} data-id="element-13" />
          <Route path="product" element={<ProductPage data-id="element-16" />} data-id="element-15" />
          <Route path="docs" element={<DocsPage data-id="element-18" />} data-id="element-17" />
          <Route path="security" element={<SecurityPage data-id="element-20" />} data-id="element-19" />
          <Route path="integrations" element={<IntegrationsPage data-id="element-22" />} data-id="element-21" />
          <Route path="faq" element={<FaqPage data-id="element-24" />} data-id="element-23" />
          <Route path="about" element={<AboutPage data-id="element-26" />} data-id="element-25" />
          <Route path="use-cases" element={<UseCasesPage data-id="element-28" />} data-id="element-27">
            <Route path=":role" element={<UseCasesPage data-id="element-30" />} data-id="element-29" />
          </Route>
          <Route path="early-access" element={<EarlyAccessPage data-id="element-32" />} data-id="element-31" />
          <Route path="privacy-policy" element={<PrivacyPolicy data-id="element-34" />} data-id="element-33" />
          <Route path="terms-of-service" element={<TermsOfService data-id="element-36" />} data-id="element-35" />
          <Route path="*" element={<HomePage data-id="element-38" />} data-id="element-37" />
        </Route>
      </Routes>
    </BrowserRouter>;
}